"use client";
import Image from "next/image";
import Button from "../common/button";
import { Heading } from "../common/typography/Heading";
import Typography from "../common/typography";
import { BlockHero } from "@/types/schema";
import { DirectusFile } from "@directus/sdk";

const PackagesHero = ({ ...props }: BlockHero) => {
  const convertedImage = props.image as unknown as DirectusFile;

  return (
    <div className="flex lg:flex-row flex-col gap-16 pb-[112px] pt-16 lg:pt-12">
      <header className="flex flex-col gap-4 lg:gap-9 justify-center">
        <div>
          <Heading size="h1" as="h1" className="mb-5">
            {props.title || "Transparent Pricing. No Hidden Fees"}
          </Heading>
          <Heading size="h6" as="p" weight={300} color="copyGray">
            {props.description_primary ||
              "Professional interior and exterior car wash and detailing, delivered to your driveway in 100+ cities across USA & Canada"}
          </Heading>
        </div>

        {/* Byline */}
        <div className="flex flex-col gap-3">

          <div
            className={`cursor-pointer mt-0 lg:mt-2.5 p-2 rounded-full w-full md:max-w-[25rem] flex items-center flex-row bg-bgColor lg:h-70px `}
          >
            <div className="flex flex-row flex-1 items-center px-2 gap-1.5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
              >
                <path
                  d="M14 14.5L10.0001 10.5M11.3333 7.16667C11.3333 9.744 9.244 11.8333 6.66667 11.8333C4.08934 11.8333 2 9.744 2 7.16667C2 4.58934 4.08934 2.5 6.66667 2.5C9.244 2.5 11.3333 4.58934 11.3333 7.16667Z"
                  stroke="#969CA9"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <Typography
                size="unresponsiveBody2"
                weight={400}
                color="copyGray"
              >
                my car
              </Typography>
            </div>

            <Button
              data-panda-price-modal
              intent="primary"
              label="See my price"
              className="!rounded-full !h-full md:flex-none  max-w-[160px] flex-1 flex items-center justify-center lg:py-0 !py-4 !px-2"
            />
          </div>

          <span className="flex gap-2 lg:justify-start justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M6.66406 12.1641C6.66406 12.1641 7.91406 13.8307 9.9974 13.8307C12.0807 13.8307 13.3307 12.1641 13.3307 12.1641M14.1641 8.19739C13.8349 8.60156 13.3849 8.83073 12.9141 8.83073C12.4432 8.83073 12.0057 8.60156 11.6641 8.19739M8.33073 8.19739C8.00156 8.60156 7.55156 8.83073 7.08073 8.83073C6.6099 8.83073 6.1724 8.60156 5.83073 8.19739M18.3307 10.4974C18.3307 15.0998 14.5998 18.8307 9.9974 18.8307C5.39502 18.8307 1.66406 15.0998 1.66406 10.4974C1.66406 5.89502 5.39502 2.16406 9.9974 2.16406C14.5998 2.16406 18.3307 5.89502 18.3307 10.4974Z"
                stroke="#6E6E73"
                stroke-width="1.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <Typography size="unresponsiveBody2" color="black">
              {props.greet_text || "Love your detail, or we&apos;ll fix it"}
            </Typography>
          </span>
        </div>
      </header>

      <figure className="relative w-full aspect-[607/552] lg:max-w-[607px] ">
        <Image
          src={convertedImage.filename_disk! || "/testimage.avif"}
          alt="Packages"
          fill
          fetchPriority="high"
          priority
          rel="preload"
          loading="eager"
          className="object-cover w-full h-full rounded-card"
        />
      </figure>
    </div>
  );
};

export default PackagesHero;
